export default "https://cdn-static.gokick.com/assets/a067049b7600101c8dd9c58c97ab0ac81c37d227/images/sleep-tangerine.755ecdb6db700f77bb8084d276871abe.png";